import type { DeliveryDetail } from '@citibox-panel/api-client';
import { formatLockerDay, lockerDayOf } from './lockerDay';

// One row of the sheet shared with Amazon. The key order IS the column order of that sheet.
export interface AddressMismatchReport {
  deliveryDate: string; // DD/MM/AAAA in the «buzón»'s zone, '' when the delivery has no stored date
  tracking: string;
  deliveredAddress: string;
  correctAddress: string;
}

export type AddressMismatchSource = Pick<DeliveryDetail, 'storedDate' | 'tracking'> & {
  location: Pick<DeliveryDetail['location'], 'timezone' | 'address'>;
};

// A tab or line break inside a cell splits the row into extra columns and shifts the sheet, with no
// error anywhere. All four cells are cleaned the same way, even though every value comes from
// backend: the sheet is outside Citibox, and nothing on the way to it checks the shape.
const sanitize = (value: string): string => value.replace(/[\t\r\n]+/g, ' ').trim();

// The date is the day the parcel was stored, resolved in the «buzón»'s zone — the day Amazon sees
// in its own records, not the agent's.
export function addressMismatchRow(
  detail: AddressMismatchSource,
  correctAddress: string,
): AddressMismatchReport {
  const day = lockerDayOf(detail.storedDate, detail.location.timezone);
  return {
    deliveryDate: day === null ? '' : formatLockerDay(day),
    tracking: sanitize(detail.tracking ?? ''),
    deliveredAddress: sanitize(detail.location.address ?? ''),
    correctAddress: sanitize(correctAddress),
  };
}
